"use client";

import { type IconProps } from "@pamperedchef/design-system";
import { capitalizeIconName } from "@/app/utilities/capitalizeIconName";
import { type ImageProps as NextImageProps } from "next/image";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

import { MeetYourConsultant } from "@/composite/MeetYourConsultant";

import type { MeetYourConsultantBlockProps } from ".";

/**
 * HeroBanner block component
 */
export function MeetYourConsultantBlock(
	props: MeetYourConsultantBlockProps
): JSX.Element {
	return (
		<MeetYourConsultant<NextLinkProps, NextImageProps>
			consultantNotChosen={{
				headline: {
					headline:
						props.consultant_not_chosen
							?.consultant_not_connected_headline?.headline ?? "",
					styledAs:
						props.consultant_not_chosen
							?.consultant_not_connected_headline
							?.headline_typography_style ?? "display-sm",
					theme:
						props.consultant_not_chosen
							?.consultant_not_connected_headline?.theme ??
						"circle",
					headingTag:
						props.consultant_not_chosen
							?.consultant_not_connected_headline?.headline_tag ??
						"h2"
				},
				eyebrow: props.consultant_not_chosen?.eyebrow ?? "",
				title: props.consultant_not_chosen?.title.headline ?? "",
				description: props.consultant_not_chosen?.description ?? "",
				cta: {
					component: NextLink,
					children:
						props.consultant_not_chosen?.cta?.link?.title ?? "",
					href: props.consultant_not_chosen?.cta?.link?.href ?? "",
					target: props.consultant_not_chosen?.cta?.open_new_tab
						? "_blank"
						: "_self",
					"aria-label":
						props.consultant_not_chosen?.cta?.assistive_text ?? ""
				}
			}}
			cards={props.cards.map((card) => ({
				title: card?.card_title?.headline ?? "",
				description: card?.card_description ?? "",
				badges: [
					{
						icon: {
							name: capitalizeIconName(card?.badge?.icon_name)
						} as IconProps,
						text: card?.badge?.description ?? ""
					}
				],
				cta: {
					component: NextLink,
					children: card?.cta?.link?.title ?? "",
					href: card?.cta?.link?.href ?? "",
					target: card?.cta?.open_new_tab ? "_blank" : "_self",
					"aria-label": card?.cta?.assistive_text ?? ""
				}
			}))}
		/>
	);
}
